import React from 'react'

interface IconProps {
  className?: string
}

const VerifiedThick = ({ className }: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <g clipPath="url(#clip0_3302_422968)">
      <path
        d="M18.5332 4.25036C18.7611 4.80163 19.1987 5.23982 19.7496 5.46859L21.6814 6.26878C22.2327 6.49714 22.6708 6.93516 22.8991 7.48647C23.1275 8.03778 23.1275 8.65723 22.8991 9.20855L22.0995 11.139C21.871 11.6905 21.8707 12.3106 22.1002 12.8619L22.8984 14.7918C23.0117 15.0648 23.0699 15.3575 23.07 15.6531C23.07 15.9487 23.0118 16.2414 22.8987 16.5145C22.7856 16.7876 22.6198 17.0358 22.4107 17.2447C22.2017 17.4537 21.9535 17.6195 21.6804 17.7325L19.7499 18.5321C19.1987 18.7601 18.7605 19.1976 18.5317 19.7485L17.7315 21.6803C17.5031 22.2317 17.0651 22.6697 16.5138 22.898C15.9625 23.1264 15.343 23.1264 14.7917 22.898L12.8613 22.0984C12.31 21.8706 11.6907 21.8711 11.1397 22.0997L9.20792 22.8988C8.65691 23.1266 8.038 23.1264 7.48713 22.8982C6.93627 22.67 6.4985 22.2325 6.26998 21.6818L5.46955 19.7494C5.24161 19.1981 4.80408 18.76 4.25315 18.5312L2.32132 17.731C1.77025 17.5027 1.33236 17.065 1.10392 16.514C0.875471 15.963 0.875161 15.3438 1.10306 14.7926L1.90267 12.8622C2.13047 12.3108 2.13001 11.6916 1.90138 11.1406L1.10291 9.20741C0.989703 8.93435 0.93141 8.64167 0.931363 8.34607C0.931315 8.05047 0.989514 7.75777 1.10263 7.48467C1.21575 7.21158 1.38158 6.96345 1.59063 6.75446C1.79968 6.54548 2.04786 6.37974 2.32099 6.26671L4.25144 5.46709C4.80223 5.23935 5.24015 4.80237 5.46909 4.25208L6.26928 2.32024C6.49764 1.76893 6.93566 1.33091 7.48697 1.10255C8.03829 0.874191 8.65774 0.874191 9.20905 1.10255L11.1395 1.90217C11.6908 2.12997 12.3101 2.1295 12.861 1.90088L14.7937 1.10379C15.3449 0.875559 15.9642 0.875606 16.5154 1.10392C17.0666 1.33224 17.5046 1.77013 17.733 2.3213L18.5334 4.25371L18.5332 4.25036Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6999 8.85437C16.8602 8.60255 16.9139 8.29735 16.8492 8.00592C16.7845 7.71449 16.6067 7.46069 16.3549 7.30037C16.1031 7.14005 15.7979 7.08633 15.5064 7.15103C15.215 7.21573 14.9612 7.39355 14.8009 7.64537L10.3954 14.5679L8.37939 12.0479C8.19301 11.8147 7.92166 11.6652 7.62502 11.6322C7.32838 11.5991 7.03077 11.6852 6.79764 11.8716C6.56452 12.058 6.41498 12.3294 6.38193 12.626C6.34887 12.9226 6.43501 13.2202 6.62139 13.4534L9.62139 17.2034C9.7332 17.3433 9.8768 17.4545 10.0402 17.5278C10.2037 17.601 10.3823 17.6342 10.5611 17.6245C10.74 17.6148 10.9139 17.5626 11.0685 17.4721C11.2231 17.3816 11.3538 17.2556 11.4499 17.1044L16.6999 8.85437Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3302_422968">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default VerifiedThick
